import type { NestableListIndentSize } from '.';

export const DEFAULT_INDENT_SIZE = 'large';

export const dataHooks = {
  nestableListCount: 'nestableList-count',
  nestableListButton: 'nestableList-button',
} as const;

export const indentSizes = ['small', 'medium', 'large'] as const;

export const depthThresholds: Readonly<Record<NestableListIndentSize, number>> =
  {
    small: 20,
    medium: 32,
    large: 84,
  };
